import React, { useState, ReactNode } from 'react';

interface Tab {
  label: string;
  content: ReactNode;
}

interface TablesToggleProperties {
  tabs: Tab[];
  defaultActive?: string;
}

/**
 * Tables toggle component
 * @param param0
 * @returns
 */
function TablesToggle({ tabs, defaultActive }: TablesToggleProperties) {
  const [active, setActive] = useState(defaultActive || tabs[0].label);

  return (
    <div className="toggle-tabs-wrapper">
      {/* Toggle Header */}
      <div className="toggle-tabs">
        {tabs.map((tab) => (
          <button
            type="button"
            key={tab.label}
            className={`toggle-tab ${active === tab.label ? 'active' : ''}`}
            onClick={() => setActive(tab.label)}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active Content */}
      <div className="toggle-content">{tabs.find((tab) => tab.label === active)?.content}</div>
    </div>
  );
}

export default TablesToggle;

TablesToggle.defaultProps = {
  defaultActive: '',
};
